<template>
    <MainContent title="Crear deportista">
        <template v-slot:header>
            <h3 class="card-title">Datos del deportista</h3>
        </template>
        <template v-slot:content>
            <div v-if="paso1">
                <PasoUnoComponent id="paso-1" :paso_activo="paso1_activo" :base="base" @terminado="terminarPasoUno()"/>
            </div>
            <div v-if="paso2">
                <PasoDosComponent id="paso-2" :paso_activo="paso2_activo" :base="base" @terminado="terminarPasoDos()" @volver="volverPasoUno()"/>
            </div>
            <div v-if="paso3">
                <PasoTresComponent id="paso-3" :paso_activo="paso3_activo" :base="base" @terminado="terminarPasoTres" @volver="volverPasoDos()" :key="reloadComponent"/>
            </div>
            <div v-if="paso4">
                <PasoCuatroComponent id="paso-4" :paso_activo="paso4_activo" :base="base" @terminado="terminarPasoCuatro()" @volver="volverPasoTres()"/>
            </div>
            <div v-if="paso5">
                <PasoCincoComponent id="paso-5" :paso_activo="paso5_activo" :base="base" @terminado="terminarPasoCinco()" @volver="volverPasoCuatro()"/>
            </div>
            <div v-if="paso6">
                <PasoSeisComponent id="paso-6" :base="base"/>
            </div>
        </template>
    </MainContent>  
</template>

<script>
import MainContent from "@/components/backend/components/MainContent";
import PasoUnoComponent from "@/components/backend/bases/components/PasoUnoComponent";
import PasoDosComponent from "@/components/backend/bases/components/PasoDosComponent";
import PasoTresComponent from "@/components/backend/bases/components/PasoTresComponent";
import PasoCuatroComponent from "@/components/backend/bases/components/PasoCuatroComponent";
import PasoCincoComponent from "@/components/backend/bases/components/PasoCincoComponent";
import PasoSeisComponent from "@/components/backend/bases/components/PasoSeisComponent.vue";

export default {
    data() {
        return {
            paso1: true,
            paso1_activo: true,
            paso2: false,
            paso2_activo: false,
            paso3: false,
            paso3_activo: false,
            paso4: false,
            paso4_activo: false,
            paso5: false,
            paso5_activo: false,
            paso6: false,
            base: {
                nacionalidad: "Española"
            },
            categorias_bases: null,
            reloadComponent: 0
        };
    },
    methods: {
        scrollTo(paso) {
            this.$scrollTo(paso, 100);
        },
        terminarPasoUno() {
            this.paso2 = true;
            this.paso2_activo = true;
            this.paso1_activo = false,
            this.$nextTick(() => {
                this.scrollTo('#paso-2');
            });                
        },
        volverPasoUno() {
            this.paso2 = false;
            this.paso2_activo = false,
            this.paso1_activo = true,
            this.$nextTick(() => {
                this.scrollTo('#paso-1');
            });
        },
        terminarPasoDos() {
            this.base.descuento_integro = 0;
            this.base.descuento_aplicado = 0;

            if (this.base.categoria_base.tiene_indumentarias) {
                this.paso3 = true;
                this.paso3_activo = true;
                this.paso2_activo = false,
                setTimeout(() => {
                    this.$nextTick(() => {
                        this.scrollTo('#paso-3');
                    });
                }, 1000);
            } else {
                this.paso4 = true;
                this.paso4_activo = true;
                this.paso2_activo = false;
                this.$nextTick(() => {
                    this.scrollTo('#paso-4');
                });
            }              
        },
        volverPasoDos() {
            this.paso3 = false;
            this.paso3_activo = false;
            this.paso2_activo = true;
            this.$nextTick(() => {
                this.scrollTo('#paso-2');
            });
        },
        terminarPasoTres(indumentariasElegidas) {
            this.base.indumentariasElegidas = indumentariasElegidas;
            this.paso4 = true;
            this.paso4_activo = true;
            this.$nextTick(() => {
                this.scrollTo('#paso-4');
            });                
        },
        volverPasoTres() {
            this.paso4 = false;
            this.paso4_activo = false;
            if (this.base.categoria_base.tiene_indumentarias) {
                this.paso3_activo = true;
                this.reloadComponent += 1;
                this.$nextTick(() => {
                    this.scrollTo('#paso-3');
                });
            } else {
                this.paso2_activo = true;
                this.$nextTick(() => {
                    this.scrollTo('#paso-2');
                });
            }
        },
        terminarPasoCuatro() {
            this.paso5 = true;
            this.paso5_activo = true;
            this.paso4_activo = false,
            this.$nextTick(() => {
                this.scrollTo('#paso-5');
            });                
        },
        volverPasoCuatro() {
            this.paso5 = false;
            this.paso5_activo = false;
            this.paso4_activo = true,
            this.$nextTick(() => {
                this.scrollTo('#paso-4');
            });                
        },
        terminarPasoCinco() {
            this.paso6 = true;
            this.paso5_activo = false;
            this.$nextTick(() => {
                this.scrollTo('#paso-6');
            });                
        },
    },
    components: {
        MainContent,
        PasoUnoComponent,
        PasoDosComponent,
        PasoTresComponent,
        PasoCuatroComponent,
        PasoCincoComponent,
        PasoSeisComponent
    },
};
</script>